import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const TRACKING_EVENT_DATA = {
  ad_impression: 1,
  category: 'ads',
  highlight_type: 'not_highlighted',
  price: 0,
  quantity: 0
}

const getTrackingData = ({models, listType}) => {
  return models.map(({makeId, modelId}, index) => ({
    ...TRACKING_EVENT_DATA,
    list_type: listType,
    id: `${makeId}:${modelId}`,
    list_position: index + 1
  }))
}
const ADD_IMPRESSIONS_COLLECTED = 'Ad Impressions Collected'

// eslint-disable-next-line react/prop-types
export const TrackingAddImpressions = ({models, listType}) => {
  const {track: analyticsTrack} = useAnalyticsTrack()
  useMount(() => {
    analyticsTrack({
      event: ADD_IMPRESSIONS_COLLECTED,
      data: {products: getTrackingData({models, listType})}
    })
  })
  return <></>
}

export const useLatestModelsTracking = () => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {TRACKING_EVENT_NAMES} = config.get('tracking')
  const {track: analyticsTrack} = useAnalyticsTrack()

  const trackModelClicked = ({make, makeId, model, modelId}) => {
    return analyticsTrack({
      event: TRACKING_EVENT_NAMES.MODEL_DETAIL_HOME_CLICKED_EVENT,
      data: {
        brand: make,
        brand_id: Number(makeId),
        model,
        model_id: Number(modelId)
      }
    })
  }

  const trackModelDetailHomeClicked = () => {
    return analyticsTrack({
      event: TRACKING_EVENT_NAMES.MODEL_DETAIL_HOME_SEARCH_CLICKED_EVENT
    })
  }

  return {
    trackModelClicked,
    trackModelDetailHomeClicked
  }
}
